export default __webpack_public_path__ + "static/089-af04aacf7f20685749f7f305bd779341.jpg";